import isDefined from '@automator/utilities/is-defined';

class Notifications {

    constructor() {

        // If no notification, bail.
        if ( ! this.hasNotification ) {
            return;
        }

        this.registerActions();
        this.state = {
            itemsCount: parseInt( uapNotifications.itemsCount ),
            lastIndex: parseInt( uapNotifications.lastIndex )
        }
        this.updateNavigation();
    }

    registerActions() {

        var controller = this;

        let nextBtns = document.getElementsByClassName( 'uap-notifications-controller-next' );

        let prevBtns = document.getElementsByClassName( 'uap-notifications-controller-prev' );

        let dismiss = document.getElementsByClassName( 'uap-notifications-action-dismiss' );

        // Next buttons.
        Array.from( nextBtns ).forEach( function( element ) {

            element.addEventListener( 'click', function() {

                let targetParent = element.parentNode.parentNode.parentNode.parentNode;

                targetParent.classList.remove( 'active' );

                targetParent.nextElementSibling.classList.add( 'active' );

                element.parentNode.parentNode.parentNode.classList.remove( 'active' );

            } );

        } );

        // Previous buttons.
        Array.from( prevBtns ).forEach( function( element ) {

            element.addEventListener( 'click', function() {

                let targetParent = element.parentNode.parentNode.parentNode.parentNode;

                targetParent.classList.remove( 'active' );

                targetParent.previousElementSibling.classList.add( 'active' );

                element.parentNode.parentNode.parentNode.classList.remove( 'active' );

            } );

        } );

        // Dismiss
        Array.from( dismiss ).forEach( function( element ) {

            element.addEventListener( 'click', function() {
                let notification_id = element.getAttribute( 'data-notification-id' );
                controller.dismissNotification( notification_id, element );
            } );

        } );
    }

    dismissNotification( notification_id, element ) {

        element.setAttribute( 'loading', true );

        _uo.utility.fetchData( {

            url: UncannyAutomatorBackend.ajax.url,

            data: {
                action: 'automator_notification_dismiss',
                nonce: UncannyAutomatorBackend.ajax.nonce,
                id: notification_id
            },

            onSuccess: ( response ) => {

                element.removeAttribute( 'loading' );

                if ( response.success ) {

                    let currentItem = element.parentNode.parentNode.parentNode;

                    currentItem.classList.remove( 'active' );

                    // Activate next item.
                    if ( parseInt( currentItem.getAttribute( 'data-index' ) ) !== this.state.lastIndex ) {
                        if ( currentItem.nextElementSibling ) {
                            currentItem.nextElementSibling.classList.add( 'active' );
                        } else {
                            // Go back to first element if there is no sibling.
                            document.querySelector( 'ul.uap-notifications-list li:first-child' ).classList.add( 'active' );
                        }
                    } else {
                        // Go back to the first element if state has last index.
                        document.querySelector( 'ul.uap-notifications-list li:first-child' ).classList.add( 'active' );
                    }

                    // Delete all element if there are no remaining.
                    if ( this.state.itemsCount === 1 ) {
                        document.querySelector( '.uap-notifications' ).remove();
                    }

                    this.state.itemsCount--;

                    // console.log( this.state.itemsCount );

                    currentItem.remove();

                    this.updateNavigation();

                }
            },
            onFail: ( response, message ) => {
                // console.log( message );
            },
        } );
    }

    updateNavigation() {

        let $prevButton = document.querySelector( 'ul.uap-notifications-list li:first-child' ).querySelector( '.uap-notifications-controller-prev' );

        let $nextButton = document.querySelector( 'ul.uap-notifications-list li:last-child' ).querySelector( '.uap-notifications-controller-next' );

        if ( $prevButton ) {
            $prevButton.setAttribute( 'disabled', true );
        }

        if ( $nextButton ) {
            $nextButton.setAttribute( 'disabled', true );
        }

    }

    get hasNotification() {

        return isDefined( document.getElementById( 'uap-notifications-wrap' ) );

    }

}

export default Notifications;
